import admin from "./admin"
import analytic from "./analytic"
import base from "./base"
import category from "./category"
import certification from "./certification"
import client from "./client"
import course from "./course"
import discount from "./discount"
import instructor from "./instructor"
import lab from "./lab"
import learningCue from "./learningCue"
import lesson from "./lesson"
import path from "./path"
import tag from "./tag"
import user from "./user"
import video from "./video"
export default {
  admin,
  analytic,
  base,
  category,
  certification,
  client,
  course,
  discount,
  instructor,
  lab,
  learningCue,
  lesson,
  path,
  tag,
  user,
  video,
}
